import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SeismicCurrencyDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-seismic-currency',
  templateUrl: './seismic-currency.component.html',
  styleUrls: ['./seismic-currency.component.scss'],
})
export class SeismicCurrencyComponent implements OnChanges {
  currencyForm: FormGroup;
  currencyFormArray: FormGroup;
  control = new FormControl();
  @Input() currencys: SeismicCurrencyDto[];
  @Input() routeAnimationsElements: any;
  @Output() currency = new EventEmitter<SeismicCurrencyDto[]>();
  @Output() deleteCurrencyEvent = new EventEmitter<any>();

  selectedCurrency: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createCurrencyForm();
  }

  createCurrencyForm() {
    this.currencyForm = this.fb.group({
      CurrencyName: ['', Validators.required],
      id: null,
    });
    this.currencyFormArray = this.fb.group({
      Currencys: this.fb.array([]),
    });
    this.setCurrency();
  }

  // method to display currencys
  setCurrency() {
    const control = this.currencyFormArray.controls.Currencys as FormArray;
    this.currencys.forEach((e) => {
      control.push(
        this.fb.group({
          CurrencyName: e.CurrencyName,
          id: e.id,
        })
      );
    });
  }

  // method to add Currency
  addCurrency(value: SeismicCurrencyDto) {
    const control = this.currencyFormArray.controls.Currencys as FormArray;
    control.insert(
      0,
      this.fb.group({
        CurrencyName: value.CurrencyName,
        id: null,
      })
    );
  }

  selectCurrency(value) {}

  // method to delete currency from arrary list
  deleteCurrency(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.currencyFormArray.controls.Currencys as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.currencys.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.currencys[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: SeismicCurrencyDto) {
    if (this.currencyForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.currencyFormArray
        .get('Currencys')
        ['controls'][this.selectedIndex].patchValue({
          CurrencyName: formValue.CurrencyName,
        });
    } else {
      this.addCurrency(formValue);
    }
    this.selectedIndex = null;
    this.currencyForm.reset();
  }

  onEdit(index, value: SeismicCurrencyDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.currencyForm.patchValue({
      CurrencyName: value.CurrencyName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.currencyForm.reset();
  }

  onSubmit(formValue: SeismicCurrencyDto[]) {
    this.currency.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteCurrencyEvent.emit(this.filteredDelete);
    }
  }
}
